import { useState, type FormEvent } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { authApi } from '../api/auth';
import { BRAND } from '../brand';
import { useTheme } from '../theme/ThemeProvider';
import { ApiError } from '../lib/api';

export function ResetPassword() {
  const { theme } = useTheme();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    if (password.length < 10) {
      setError('Use at least 10 characters.');
      return;
    }
    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }
    if (!token) {
      setError('This reset link is invalid.');
      return;
    }
    setError(null);
    setSubmitting(true);
    try {
      await authApi.resetPassword(token, password);
      navigate('/login');
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Could not reset password.');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="mx-auto max-w-sm">
      <img
        src={theme === 'dark' ? BRAND.logoSrc : BRAND.logoOriginal}
        alt={BRAND.name}
        className="mx-auto mb-6 w-full max-w-xs"
      />
      <h1 className="mb-6 text-center font-display text-3xl text-cream-50">Choose a new password</h1>
      <form onSubmit={onSubmit} className="card space-y-4">
        {error && (
          <p className="rounded border border-wine-500/50 bg-wine-900/40 px-3 py-2 text-sm text-wine-100">
            {error}
          </p>
        )}
        <div>
          <label className="mb-1 block text-xs uppercase tracking-wide text-cream-300/70">New password</label>
          <input
            type="password"
            className="field"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="new-password"
            minLength={10}
            required
          />
        </div>
        <div>
          <label className="mb-1 block text-xs uppercase tracking-wide text-cream-300/70">Confirm password</label>
          <input
            type="password"
            className="field"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            autoComplete="new-password"
            minLength={10}
            required
          />
        </div>
        <button type="submit" className="btn-primary w-full" disabled={submitting}>
          {submitting ? 'Saving…' : 'Update password'}
        </button>
        <Link to="/login" className="btn-ghost block w-full text-center text-sm">
          Back to sign in
        </Link>
      </form>
    </div>
  );
}
